// NOTE: This should be kept in sync with back-end Event model's `NAMES` (see event.rb).
export enum EventName {
  // Account events
  AccountCreated = 'account.created',
  AccountRedacted = 'account.redacted',
  AccountArchived = 'account.archived',
  AccountRestored = 'account.restored',
  AccountConsolidated = 'account.consolidated',
  AccountStatusUpdated = 'account.status-updated',
  AccountTagAdded = 'account.tag-added',
  AccountTagRemoved = 'account.tag-removed',
  AccountUpdatedFields = 'account.updated-fields',

  // Case events
  CaseCreated = 'case.created',
  CaseAssigned = 'case.assigned',
  CaseUpdated = 'case.updated',
  CaseResolved = 'case.resolved',
  CaseReopened = 'case.reopened',
  CaseStatusUpdated = 'case.status-updated',
  CaseSlaExpired = 'case.sla-expired',
  CaseQueueUpdated = 'case.queue-updated',

  // Case Message events
  CaseMessageSent = 'case-message.sent',
  CaseMessageReceived = 'case-message.received',

  // Graph query events
  GraphQueryCancelled = 'graph-query.cancelled',
  GraphQueryCompleted = 'graph-query.completed',
  GraphQueryErrored = 'graph-query.errored',
  GraphQueryReran = 'graph-query.reran',
  GraphQuerySubmitted = 'graph-query.submitted',
  GraphQueryTimedOut = 'graph-query.timed-out',

  // Document events
  DocumentCreated = 'document.created',
  DocumentSubmitted = 'document.submitted',
  DocumentExtracted = 'document.extracted',
  DocumentProcessed = 'document.processed',
  DocumentErrored = 'document.errored',

  // External Integration log events
  ExternalIntegrationLogCreated = 'integration-log.created',

  // Inquiry events
  InquiryCreated = 'inquiry.created',
  InquiryStarted = 'inquiry.started',
  InquiryExpired = 'inquiry.expired',
  InquiryTransitioned = 'inquiry.transitioned',
  InquiryCompleted = 'inquiry.completed',
  InquiryFailed = 'inquiry.failed',
  InquiryMarkedForReview = 'inquiry.marked-for-review',
  InquiryApproved = 'inquiry.approved',
  InquiryDeclined = 'inquiry.declined',
  InquiryRedacted = 'inquiry.redacted',
  InquiryReusablePersonaCreated = 'inquiry.reusable-persona-created',
  InquiryReusablePersonaUsed = 'inquiry.reusable-persona-used',

  // Inquiry run event
  // NOTE: client-side only name used to provide common interface between
  // inquiry transition events and chosen direct workflow run conditionals
  // TODO (eric): remove when Inquiry Run model introduced
  // TODO (FLE-288): remove this non-Event model event
  InquiryRunConditionalRouted = 'inquiry-run.conditional-routed',

  // Inquiry session events
  InquirySessionStarted = 'inquiry-session.started',
  InquirySessionExpired = 'inquiry-session.expired',
  InquirySessionCanceled = 'inquiry-session.canceled',

  // Inquiry template version events
  InquiryTemplateVersionCreated = 'inquiry-template-version.created',
  InquiryTemplateVersionPublished = 'inquiry-template-version.published',

  // Report events
  ReportAddressLookupErrored = 'report/address-lookup.errored',
  ReportAddressLookupReady = 'report/address-lookup.ready',
  ReportAdverseMediaDismissed = 'report/adverse-media.dismissed',
  ReportAdverseMediaErrored = 'report/adverse-media.errored',
  ReportAdverseMediaMatched = 'report/adverse-media.matched',
  ReportAdverseMediaReady = 'report/adverse-media.ready',
  ReportBusinessAdverseMediaDismissed = 'report/business-adverse-media.dismissed',
  ReportBusinessAdverseMediaErrored = 'report/business-adverse-media.errored',
  ReportBusinessAdverseMediaMatched = 'report/business-adverse-media.matched',
  ReportBusinessAdverseMediaReady = 'report/business-adverse-media.ready',
  ReportBusinessAssociatedPersonsErrored = 'report/business-associated-persons.errored',
  ReportBusinessAssociatedPersonsMatched = 'report/business-associated-persons.matched',
  ReportBusinessAssociatedPersonsReady = 'report/business-associated-persons.ready',
  ReportBusinessClassificationErrored = 'report/business-classification.errored',
  ReportBusinessClassificationReady = 'report/business-classification.ready',
  ReportBusinessIndustryClassificationErrored = 'report/business-industry-classification.errored',
  ReportBusinessIndustryClassificationReady = 'report/business-industry-classification.ready',
  ReportBusinessIndustryClassificationSubmitted = 'report/business-industry-classification.submitted',
  ReportBusinessLiensLookupErrored = 'report/business-liens-lookup.errored',
  ReportBusinessLiensLookupReady = 'report/business-liens-lookup.ready',
  ReportBusinessLookupErrored = 'report/business-lookup.errored',
  ReportBusinessLookupReady = 'report/business-lookup.ready',
  ReportBusinessNonprofitChanged = 'report/business-nonprofit.changed',
  ReportBusinessNonprofitErrored = 'report/business-nonprofit.errored',
  ReportBusinessNonprofitReady = 'report/business-nonprofit.ready',
  ReportBusinessOnlinePresenceErrored = 'report/business-online-presence.errored',
  ReportBusinessOnlinePresenceReady = 'report/business-online-presence.ready',
  ReportBusinessOnlinePresenceSubmitted = 'report/business-online-presence.submitted',
  ReportBusinessRegistrationsLookupErrored = 'report/business-registrations-lookup.errored',
  ReportBusinessRegistrationsLookupReady = 'report/business-registrations-lookup.ready',
  ReportBusinessSocialMediaErrored = 'report/business-social-media.errored',
  ReportBusinessSocialMediaReady = 'report/business-social-media.ready',
  ReportBusinessWatchlistDismissed = 'report/business-watchlist.dismissed',
  ReportBusinessWatchlistErrored = 'report/business-watchlist.errored',
  ReportBusinessWatchlistMatched = 'report/business-watchlist.matched',
  ReportBusinessWatchlistReady = 'report/business-watchlist.ready',
  ReportBusinessWebsiteErrored = 'report/business-website.errored',
  ReportBusinessWebsiteReady = 'report/business-website.ready',
  ReportClearbitBusinessLookupErrored = 'report/clearbit-business-lookup.errored',
  ReportClearbitBusinessLookupReady = 'report/clearbit-business-lookup.ready',
  ReportCryptoAddressWatchlistErrored = 'report/crypto-address-watchlist.errored',
  ReportCryptoAddressWatchlistMatched = 'report/crypto-address-watchlist.matched',
  ReportCryptoAddressWatchlistReady = 'report/crypto-address-watchlist.ready',
  ReportCustomListDismissed = 'report/custom-list.dismissed',
  ReportCustomListErrored = 'report/custom-list.errored',
  ReportCustomListMatched = 'report/custom-list.matched',
  ReportCustomListReady = 'report/custom-list.ready',
  ReportEmailAddressErrored = 'report/email-address.errored',
  ReportEmailAddressReady = 'report/email-address.ready',
  ReportFinraBrokerCheckErrored = 'report/finra-broker-check.errored',
  ReportFinraBrokerCheckReady = 'report/finra-broker-check.ready',
  ReportKyckrBusinessLookupErrored = 'report/kyckr-business-lookup.errored',
  ReportKyckrBusinessLookupReady = 'report/kyckr-business-lookup.ready',
  ReportMiddeskErrored = 'report/middesk.errored',
  ReportMiddeskReady = 'report/middesk.ready',
  ReportMxAccountErrored = 'report/mx-account.errored',
  ReportMxAccountReady = 'report/mx-account.ready',
  ReportPhoneNumberErrored = 'report/phone-number.errored',
  ReportPhoneNumberReady = 'report/phone-number.ready',
  ReportPoliticallyExposedPersonDismissed = 'report/politically-exposed-person.dismissed',
  ReportPoliticallyExposedPersonErrored = 'report/politically-exposed-person.errored',
  ReportPoliticallyExposedPersonMatched = 'report/politically-exposed-person.matched',
  ReportPoliticallyExposedPersonReady = 'report/politically-exposed-person.ready',
  ReportProfileErrored = 'report/profile.errored',
  ReportProfileReady = 'report/profile.ready',
  ReportProfileNonAuthoritativeErrored = 'report/profile-non-authoritative.errored',
  ReportProfileNonAuthoritativeReady = 'report/profile-non-authoritative.ready',
  ReportScreeningErrored = 'report/screening.errored',
  ReportScreeningReady = 'report/screening.ready',
  ReportSecActionLookupErrored = 'report/sec-action-lookup.errored',
  ReportSecActionLookupReady = 'report/sec-action-lookup.ready',
  ReportSentilinkApplicationRiskErrored = 'report/sentilink-application-risk.errored',
  ReportSentilinkApplicationRiskReady = 'report/sentilink-application-risk.ready',
  ReportSentilinkScoresErrored = 'report/sentilink-scores.errored',
  ReportSentilinkScoresReady = 'report/sentilink-scores.ready',
  ReportSocialMediaErrored = 'report/social-media.errored',
  ReportSocialMediaReady = 'report/social-media.ready',
  ReportSyntheticErrored = 'report/synthetic.errored',
  ReportSyntheticReady = 'report/synthetic.ready',
  ReportWatchlistDismissed = 'report/watchlist.dismissed',
  ReportWatchlistErrored = 'report/watchlist.errored',
  ReportWatchlistMatched = 'report/watchlist.matched',
  ReportWatchlistReady = 'report/watchlist.ready',

  // SAR events
  SARCreated = 'sar.created',
  SARFiled = 'sar.filed',

  // Selfie events
  SelfieCreated = 'selfie.created',
  SelfieSubmitted = 'selfie.submitted',
  SelfieProcessed = 'selfie.processed',
  SelfieErrored = 'selfie.errored',

  // Session events
  SessionCreated = 'session.created',
  SessionExpired = 'session.expired',

  // Transaction events
  TransactionCreated = 'transaction.created',
  TransactionLabeled = 'transaction.labeled',
  TransactionRedacted = 'transaction.redacted',
  TransactionStatusUpdated = 'transaction.status-updated',

  // Verification events
  VerificationCreated = 'verification.created',
  VerificationSubmitted = 'verification.submitted',
  VerificationPassed = 'verification.passed',
  VerificationRequiresRetry = 'verification.requires-retry',
  VerificationFailed = 'verification.failed',
  VerificationCanceled = 'verification.canceled',
  VerificationTentativelyPassed = 'verification.tentatively-passed',
  VerificationTentativelyFailed = 'verification.tentatively-failed',

  // WorkflowRun events
  WorkflowRunCreated = 'workflow-run.created',
  WorkflowRunErrored = 'workflow-run.errored',
  WorkflowRunResumed = 'workflow-run.resumed',
}

export enum EventType {
  Account = 'Account',
  Case = 'Case',
  CaseMessage = 'CaseMessage',
  Document = 'Document',
  ExternalIntegrationLog = 'ExternalIntegrationLog',
  GraphQuery = 'GraphQuery',
  Inquiry = 'Inquiry',
  InquiryTemplateVersion = 'InquiryTemplateVersion',
  Report = 'Report',
  SAR = 'SAR',
  Selfie = 'Selfie',
  Session = 'Session',
  Transaction = 'Transaction',
  Verification = 'Verification',
  WorkflowRun = 'WorkflowRun',
}

export const EVENT_NAME_TO_DESCRIPTION: Record<EventName, string> = {
  // Account events
  [EventName.AccountCreated]: 'Account created',
  [EventName.AccountRedacted]: 'Account redacted',
  [EventName.AccountArchived]: 'Account archived',
  [EventName.AccountRestored]: 'Account restored',
  [EventName.AccountConsolidated]: 'Account consolidated',
  [EventName.AccountStatusUpdated]: 'Account status updated',
  [EventName.AccountTagAdded]: 'Account tag added',
  [EventName.AccountTagRemoved]: 'Account tag removed',
  [EventName.AccountUpdatedFields]: 'Account field updated',

  // Case events
  [EventName.CaseCreated]: 'Case created',
  [EventName.CaseAssigned]: 'Case assigned',
  [EventName.CaseUpdated]: 'Case updated',
  [EventName.CaseQueueUpdated]: 'Case queue updated',
  [EventName.CaseResolved]: 'Case resolved',
  [EventName.CaseReopened]: 'Case reopened',
  [EventName.CaseSlaExpired]: 'Case SLA expired',
  [EventName.CaseStatusUpdated]: 'Case status updated',

  // Case Message Events
  [EventName.CaseMessageSent]: 'Case message sent',
  [EventName.CaseMessageReceived]: 'Case message received',

  // Document events
  [EventName.DocumentCreated]: 'Document created',
  [EventName.DocumentSubmitted]: 'Document submitted',
  [EventName.DocumentExtracted]: 'Document extracted',
  [EventName.DocumentProcessed]: 'Document processed',
  [EventName.DocumentErrored]: 'Document error',

  // Graph query events
  [EventName.GraphQueryCancelled]: 'Graph query cancelled',
  [EventName.GraphQueryCompleted]: 'Graph query completed',
  [EventName.GraphQueryErrored]: 'Graph query errored',
  [EventName.GraphQueryReran]: 'Graph query reran',
  [EventName.GraphQuerySubmitted]: 'Graph query submitted',
  [EventName.GraphQueryTimedOut]: 'Graph query timed out',

  // Inquiry events
  [EventName.InquiryCreated]: 'Inquiry created',
  [EventName.InquiryStarted]: 'Inquiry started',
  [EventName.InquiryExpired]: 'Inquiry expired',
  [EventName.InquiryCompleted]: 'Inquiry completed',
  [EventName.InquiryFailed]: 'Inquiry failed',
  [EventName.InquiryMarkedForReview]: 'Inquiry marked for review',
  [EventName.InquiryApproved]: 'Inquiry approved',
  [EventName.InquiryDeclined]: 'Inquiry declined',
  [EventName.InquiryTransitioned]: 'Inquiry transitioned',
  [EventName.InquiryRedacted]: 'Inquiry redacted',
  [EventName.InquiryReusablePersonaCreated]: 'Reusable persona created from inquiry',
  [EventName.InquiryReusablePersonaUsed]: 'Reusable persona used on inquiry',

  // Inquiry run events
  [EventName.InquiryRunConditionalRouted]: 'Inquiry run conditional routed',

  // Inquiry session events
  [EventName.InquirySessionStarted]: 'Inquiry session started',
  [EventName.InquirySessionExpired]: 'Inquiry session expired',
  [EventName.InquirySessionCanceled]: 'Inquiry session canceled',

  // Inquiry template version event
  [EventName.InquiryTemplateVersionCreated]: 'Inquiry template version created',
  [EventName.InquiryTemplateVersionPublished]: 'Inquiry template version published',

  // External Integration log event
  [EventName.ExternalIntegrationLogCreated]: 'External Integration log created',

  // Report events
  [EventName.ReportAddressLookupErrored]: 'Address lookup report errored',
  [EventName.ReportAddressLookupReady]: 'Address lookup report ready',
  [EventName.ReportAdverseMediaDismissed]: 'Adverse media report dismissed',
  [EventName.ReportAdverseMediaErrored]: 'Adverse media report errored',
  [EventName.ReportAdverseMediaMatched]: 'Adverse media report matched',
  [EventName.ReportAdverseMediaReady]: 'Adverse media report ready',
  [EventName.ReportBusinessAdverseMediaDismissed]: 'Business adverse media report dismissed',
  [EventName.ReportBusinessAdverseMediaErrored]: 'Business adverse media report errored',
  [EventName.ReportBusinessAdverseMediaMatched]: 'Business adverse media report matched',
  [EventName.ReportBusinessAdverseMediaReady]: 'Business adverse media report ready',
  [EventName.ReportBusinessClassificationErrored]: 'Business classification report errored',
  [EventName.ReportBusinessClassificationReady]: 'Business classification report ready',
  [EventName.ReportBusinessIndustryClassificationErrored]:
    'Business industry classification report errored',
  [EventName.ReportBusinessIndustryClassificationReady]:
    'Business industry classification report ready',
  [EventName.ReportBusinessIndustryClassificationSubmitted]:
    'Business industry classification report submitted',
  [EventName.ReportBusinessLiensLookupErrored]: 'Business liens report errored',
  [EventName.ReportBusinessLiensLookupReady]: 'Business liens report ready',
  [EventName.ReportBusinessLookupErrored]: 'Business lookup report errored',
  [EventName.ReportBusinessLookupReady]: 'Business lookup report ready',
  [EventName.ReportBusinessNonprofitChanged]: 'Business nonprofit report changed',
  [EventName.ReportBusinessNonprofitErrored]: 'Business nonprofit report errored',
  [EventName.ReportBusinessNonprofitReady]: 'Business nonprofit report ready',
  [EventName.ReportBusinessOnlinePresenceErrored]: 'Business online presence report errored',
  [EventName.ReportBusinessOnlinePresenceReady]: 'Business online presence report ready',
  [EventName.ReportBusinessOnlinePresenceSubmitted]: 'Business online presence report submitted',
  [EventName.ReportBusinessRegistrationsLookupErrored]: 'Business registrations report errored',
  [EventName.ReportBusinessRegistrationsLookupReady]: 'Business registrations report ready',
  [EventName.ReportBusinessSocialMediaErrored]: 'Business social media report errored',
  [EventName.ReportBusinessSocialMediaReady]: 'Business social media report ready',
  [EventName.ReportBusinessWebsiteErrored]: 'Business website report errored',
  [EventName.ReportBusinessWebsiteReady]: 'Business website report ready',
  [EventName.ReportClearbitBusinessLookupErrored]: 'Clearbit business lookup report errored',
  [EventName.ReportClearbitBusinessLookupReady]: 'Clearbit business lookup report ready',
  [EventName.ReportCryptoAddressWatchlistErrored]: 'Crypto address watchlist report errored',
  [EventName.ReportCryptoAddressWatchlistMatched]: 'Crypto address watchlist report matched',
  [EventName.ReportCryptoAddressWatchlistReady]: 'Crypto address watchlist report ready',
  [EventName.ReportCustomListDismissed]: 'Custom list report dismissed',
  [EventName.ReportCustomListErrored]: 'Custom list report errored',
  [EventName.ReportCustomListMatched]: 'Custom list report matched',
  [EventName.ReportCustomListReady]: 'Custom list report ready',
  [EventName.ReportBusinessAssociatedPersonsErrored]: 'Business associated persons report errored',
  [EventName.ReportBusinessAssociatedPersonsMatched]: 'Business associated persons report matched',
  [EventName.ReportBusinessAssociatedPersonsReady]: 'Business associated persons report ready',
  [EventName.ReportBusinessWatchlistDismissed]: 'Business watchlist report dismissed',
  [EventName.ReportBusinessWatchlistErrored]: 'Business watchlist report errored',
  [EventName.ReportBusinessWatchlistMatched]: 'Business watchlist report matched',
  [EventName.ReportBusinessWatchlistReady]: 'Business watchlist report ready',
  [EventName.ReportEmailAddressErrored]: 'Email risk report errored',
  [EventName.ReportEmailAddressReady]: 'Email risk report ready',
  [EventName.ReportFinraBrokerCheckErrored]: 'Finra broker check report errored',
  [EventName.ReportFinraBrokerCheckReady]: 'Finra broker check report ready',
  [EventName.ReportKyckrBusinessLookupErrored]: 'Kyckr Business Lookup report errored',
  [EventName.ReportKyckrBusinessLookupReady]: 'Kyckr Business Lookup report ready',
  [EventName.ReportMiddeskReady]: 'Middesk report ready',
  [EventName.ReportMiddeskErrored]: 'Middesk report errored',
  [EventName.ReportMxAccountErrored]: 'Mx account report errored',
  [EventName.ReportMxAccountReady]: 'Mx account report ready',
  [EventName.ReportPhoneNumberErrored]: 'Phone risk report errored',
  [EventName.ReportPhoneNumberReady]: 'Phone risk report ready',
  [EventName.ReportPoliticallyExposedPersonDismissed]:
    'Politically Exposed Person report dismissed',
  [EventName.ReportPoliticallyExposedPersonErrored]: 'Politically Exposed Person report errored',
  [EventName.ReportPoliticallyExposedPersonMatched]: 'Politically Exposed Person report matched',
  [EventName.ReportPoliticallyExposedPersonReady]: 'Politically Exposed Person report ready',
  [EventName.ReportProfileErrored]: 'Profile report errored',
  [EventName.ReportProfileReady]: 'Profile report ready',
  [EventName.ReportProfileNonAuthoritativeErrored]: 'Profile Non-Authoritative report errored',
  [EventName.ReportProfileNonAuthoritativeReady]: 'Profile Non-Authoritative report ready',
  [EventName.ReportScreeningErrored]: 'Screening report errored',
  [EventName.ReportScreeningReady]: 'Screening report ready',
  [EventName.ReportSecActionLookupErrored]: 'SEC action lookup report errored',
  [EventName.ReportSecActionLookupReady]: 'SEC action lookup report ready',
  [EventName.ReportSentilinkApplicationRiskErrored]: 'SentiLink application risk report errored',
  [EventName.ReportSentilinkApplicationRiskReady]: 'SentiLink application risk report ready',
  [EventName.ReportSentilinkScoresErrored]: 'SentiLink scores report errored',
  [EventName.ReportSentilinkScoresReady]: 'SentiLink scores report ready',
  [EventName.ReportSocialMediaErrored]: 'Social media report errored',
  [EventName.ReportSocialMediaReady]: 'Social media report ready',
  [EventName.ReportSyntheticErrored]: 'Synthetic report errored',
  [EventName.ReportSyntheticReady]: 'Synthetic report ready',
  [EventName.ReportWatchlistDismissed]: 'Watchlist report dismissed',
  [EventName.ReportWatchlistErrored]: 'Watchlist report errored',
  [EventName.ReportWatchlistMatched]: 'Watchlist report matched',
  [EventName.ReportWatchlistReady]: 'Watchlist report ready',

  // SAR events
  [EventName.SARCreated]: 'SAR created',
  [EventName.SARFiled]: 'SAR filed',

  // Selfie events
  [EventName.SelfieCreated]: 'Selfie created',
  [EventName.SelfieSubmitted]: 'Selfie submitted',
  [EventName.SelfieProcessed]: 'Selfie processed',
  [EventName.SelfieErrored]: 'Selfie errored',

  // Session events
  [EventName.SessionCreated]: 'Session created',
  [EventName.SessionExpired]: 'Session expired',

  // Transaction events
  [EventName.TransactionCreated]: 'Transaction created',
  [EventName.TransactionLabeled]: 'Transaction labeled',
  [EventName.TransactionStatusUpdated]: 'Transaction status updated',
  [EventName.TransactionRedacted]: 'Transaction redacted',

  // Verification events
  [EventName.VerificationCreated]: 'Verification created',
  [EventName.VerificationSubmitted]: 'Verification submitted',
  [EventName.VerificationPassed]: 'Verification passed',
  [EventName.VerificationRequiresRetry]: 'Verification requires retry',
  [EventName.VerificationFailed]: 'Verification failed',
  [EventName.VerificationCanceled]: 'Verification canceled',
  [EventName.VerificationTentativelyPassed]: 'Verification tentatively passed',
  [EventName.VerificationTentativelyFailed]: 'Verification tentatively failed',

  // WorkflowRun events
  [EventName.WorkflowRunCreated]: 'Workflow run created',
  [EventName.WorkflowRunErrored]: 'Workflow run errored',
  [EventName.WorkflowRunResumed]: 'Workflow run resumed',
};

export const EVENT_NAME_TO_EVENT_TYPE: Record<EventName, EventType> = {
  // Account events
  [EventName.AccountCreated]: EventType.Account,
  [EventName.AccountRedacted]: EventType.Account,
  [EventName.AccountArchived]: EventType.Account,
  [EventName.AccountRestored]: EventType.Account,
  [EventName.AccountConsolidated]: EventType.Account,
  [EventName.AccountStatusUpdated]: EventType.Account,
  [EventName.AccountTagAdded]: EventType.Account,
  [EventName.AccountTagRemoved]: EventType.Account,
  [EventName.AccountUpdatedFields]: EventType.Account,

  // Case events
  [EventName.CaseQueueUpdated]: EventType.Case,
  [EventName.CaseCreated]: EventType.Case,
  [EventName.CaseAssigned]: EventType.Case,
  [EventName.CaseUpdated]: EventType.Case,
  [EventName.CaseResolved]: EventType.Case,
  [EventName.CaseReopened]: EventType.Case,
  [EventName.CaseSlaExpired]: EventType.Case,
  [EventName.CaseStatusUpdated]: EventType.Case,

  // Case mesage events
  [EventName.CaseMessageSent]: EventType.CaseMessage,
  [EventName.CaseMessageReceived]: EventType.CaseMessage,

  // Document events
  [EventName.DocumentCreated]: EventType.Document,
  [EventName.DocumentSubmitted]: EventType.Document,
  [EventName.DocumentExtracted]: EventType.Document,
  [EventName.DocumentProcessed]: EventType.Document,
  [EventName.DocumentErrored]: EventType.Document,

  // External Integration log events
  [EventName.ExternalIntegrationLogCreated]: EventType.ExternalIntegrationLog,

  // Graph query events
  [EventName.GraphQueryCancelled]: EventType.GraphQuery,
  [EventName.GraphQueryCompleted]: EventType.GraphQuery,
  [EventName.GraphQueryErrored]: EventType.GraphQuery,
  [EventName.GraphQueryReran]: EventType.GraphQuery,
  [EventName.GraphQuerySubmitted]: EventType.GraphQuery,
  [EventName.GraphQueryTimedOut]: EventType.GraphQuery,

  // Inquiry events
  [EventName.InquiryCreated]: EventType.Inquiry,
  [EventName.InquiryStarted]: EventType.Inquiry,
  [EventName.InquiryExpired]: EventType.Inquiry,
  [EventName.InquiryCompleted]: EventType.Inquiry,
  [EventName.InquiryFailed]: EventType.Inquiry,
  [EventName.InquiryMarkedForReview]: EventType.Inquiry,
  [EventName.InquiryApproved]: EventType.Inquiry,
  [EventName.InquiryDeclined]: EventType.Inquiry,
  [EventName.InquiryTransitioned]: EventType.Inquiry,
  [EventName.InquiryRedacted]: EventType.Inquiry,
  [EventName.InquiryReusablePersonaCreated]: EventType.Inquiry,
  [EventName.InquiryReusablePersonaUsed]: EventType.Inquiry,

  // Inquiry run events
  [EventName.InquiryRunConditionalRouted]: EventType.Inquiry,

  // Inquiry session events
  [EventName.InquirySessionStarted]: EventType.Inquiry,
  [EventName.InquirySessionExpired]: EventType.Inquiry,
  [EventName.InquirySessionCanceled]: EventType.Inquiry,

  // Inquiry template version events
  [EventName.InquiryTemplateVersionCreated]: EventType.InquiryTemplateVersion,
  [EventName.InquiryTemplateVersionPublished]: EventType.InquiryTemplateVersion,

  // Report events
  [EventName.ReportAddressLookupErrored]: EventType.Report,
  [EventName.ReportAddressLookupReady]: EventType.Report,
  [EventName.ReportAdverseMediaDismissed]: EventType.Report,
  [EventName.ReportAdverseMediaErrored]: EventType.Report,
  [EventName.ReportAdverseMediaMatched]: EventType.Report,
  [EventName.ReportAdverseMediaReady]: EventType.Report,
  [EventName.ReportBusinessAdverseMediaDismissed]: EventType.Report,
  [EventName.ReportBusinessAdverseMediaErrored]: EventType.Report,
  [EventName.ReportBusinessAdverseMediaMatched]: EventType.Report,
  [EventName.ReportBusinessClassificationErrored]: EventType.Report,
  [EventName.ReportBusinessClassificationReady]: EventType.Report,
  [EventName.ReportBusinessIndustryClassificationErrored]: EventType.Report,
  [EventName.ReportBusinessIndustryClassificationReady]: EventType.Report,
  [EventName.ReportBusinessIndustryClassificationSubmitted]: EventType.Report,
  [EventName.ReportBusinessAdverseMediaReady]: EventType.Report,
  [EventName.ReportBusinessLiensLookupErrored]: EventType.Report,
  [EventName.ReportBusinessLiensLookupReady]: EventType.Report,
  [EventName.ReportBusinessLookupErrored]: EventType.Report,
  [EventName.ReportBusinessLookupReady]: EventType.Report,
  [EventName.ReportBusinessNonprofitChanged]: EventType.Report,
  [EventName.ReportBusinessNonprofitErrored]: EventType.Report,
  [EventName.ReportBusinessNonprofitReady]: EventType.Report,
  [EventName.ReportBusinessOnlinePresenceErrored]: EventType.Report,
  [EventName.ReportBusinessOnlinePresenceReady]: EventType.Report,
  [EventName.ReportBusinessOnlinePresenceSubmitted]: EventType.Report,
  [EventName.ReportBusinessRegistrationsLookupErrored]: EventType.Report,
  [EventName.ReportBusinessRegistrationsLookupReady]: EventType.Report,
  [EventName.ReportBusinessSocialMediaErrored]: EventType.Report,
  [EventName.ReportBusinessSocialMediaReady]: EventType.Report,
  [EventName.ReportBusinessAssociatedPersonsErrored]: EventType.Report,
  [EventName.ReportBusinessAssociatedPersonsMatched]: EventType.Report,
  [EventName.ReportBusinessAssociatedPersonsReady]: EventType.Report,
  [EventName.ReportBusinessWatchlistDismissed]: EventType.Report,
  [EventName.ReportBusinessWatchlistErrored]: EventType.Report,
  [EventName.ReportBusinessWatchlistMatched]: EventType.Report,
  [EventName.ReportBusinessWatchlistReady]: EventType.Report,
  [EventName.ReportBusinessWebsiteErrored]: EventType.Report,
  [EventName.ReportBusinessWebsiteReady]: EventType.Report,
  [EventName.ReportClearbitBusinessLookupErrored]: EventType.Report,
  [EventName.ReportClearbitBusinessLookupReady]: EventType.Report,
  [EventName.ReportCryptoAddressWatchlistErrored]: EventType.Report,
  [EventName.ReportCryptoAddressWatchlistMatched]: EventType.Report,
  [EventName.ReportCryptoAddressWatchlistReady]: EventType.Report,
  [EventName.ReportCustomListDismissed]: EventType.Report,
  [EventName.ReportCustomListErrored]: EventType.Report,
  [EventName.ReportCustomListMatched]: EventType.Report,
  [EventName.ReportCustomListReady]: EventType.Report,
  [EventName.ReportEmailAddressErrored]: EventType.Report,
  [EventName.ReportEmailAddressReady]: EventType.Report,
  [EventName.ReportFinraBrokerCheckErrored]: EventType.Report,
  [EventName.ReportFinraBrokerCheckReady]: EventType.Report,
  [EventName.ReportKyckrBusinessLookupErrored]: EventType.Report,
  [EventName.ReportKyckrBusinessLookupReady]: EventType.Report,
  [EventName.ReportMiddeskReady]: EventType.Report,
  [EventName.ReportMiddeskErrored]: EventType.Report,
  [EventName.ReportMxAccountErrored]: EventType.Report,
  [EventName.ReportMxAccountReady]: EventType.Report,
  [EventName.ReportPhoneNumberErrored]: EventType.Report,
  [EventName.ReportPhoneNumberReady]: EventType.Report,
  [EventName.ReportPoliticallyExposedPersonDismissed]: EventType.Report,
  [EventName.ReportPoliticallyExposedPersonErrored]: EventType.Report,
  [EventName.ReportPoliticallyExposedPersonMatched]: EventType.Report,
  [EventName.ReportPoliticallyExposedPersonReady]: EventType.Report,
  [EventName.ReportProfileErrored]: EventType.Report,
  [EventName.ReportProfileReady]: EventType.Report,
  [EventName.ReportProfileNonAuthoritativeErrored]: EventType.Report,
  [EventName.ReportProfileNonAuthoritativeReady]: EventType.Report,
  [EventName.ReportSecActionLookupErrored]: EventType.Report,
  [EventName.ReportSecActionLookupReady]: EventType.Report,
  [EventName.ReportSentilinkApplicationRiskErrored]: EventType.Report,
  [EventName.ReportSentilinkApplicationRiskReady]: EventType.Report,
  [EventName.ReportSentilinkScoresErrored]: EventType.Report,
  [EventName.ReportSentilinkScoresReady]: EventType.Report,
  [EventName.ReportSocialMediaErrored]: EventType.Report,
  [EventName.ReportSocialMediaReady]: EventType.Report,
  [EventName.ReportSyntheticErrored]: EventType.Report,
  [EventName.ReportSyntheticReady]: EventType.Report,
  [EventName.ReportScreeningErrored]: EventType.Report,
  [EventName.ReportScreeningReady]: EventType.Report,
  [EventName.ReportWatchlistDismissed]: EventType.Report,
  [EventName.ReportWatchlistErrored]: EventType.Report,
  [EventName.ReportWatchlistMatched]: EventType.Report,
  [EventName.ReportWatchlistReady]: EventType.Report,

  // SAR events
  [EventName.SARCreated]: EventType.SAR,
  [EventName.SARFiled]: EventType.SAR,

  // Selfie events
  [EventName.SelfieCreated]: EventType.Selfie,
  [EventName.SelfieSubmitted]: EventType.Selfie,
  [EventName.SelfieProcessed]: EventType.Selfie,
  [EventName.SelfieErrored]: EventType.Selfie,

  // Session events
  [EventName.SessionCreated]: EventType.Session,
  [EventName.SessionExpired]: EventType.Session,

  // Transaction events
  [EventName.TransactionCreated]: EventType.Transaction,
  [EventName.TransactionLabeled]: EventType.Transaction,
  [EventName.TransactionStatusUpdated]: EventType.Transaction,
  [EventName.TransactionRedacted]: EventType.Transaction,

  // Verification events
  [EventName.VerificationCreated]: EventType.Verification,
  [EventName.VerificationSubmitted]: EventType.Verification,
  [EventName.VerificationPassed]: EventType.Verification,
  [EventName.VerificationRequiresRetry]: EventType.Verification,
  [EventName.VerificationFailed]: EventType.Verification,
  [EventName.VerificationCanceled]: EventType.Verification,
  [EventName.VerificationTentativelyPassed]: EventType.Verification,
  [EventName.VerificationTentativelyFailed]: EventType.Verification,

  // WorkflowRun events
  [EventName.WorkflowRunCreated]: EventType.WorkflowRun,
  [EventName.WorkflowRunErrored]: EventType.WorkflowRun,
  [EventName.WorkflowRunResumed]: EventType.WorkflowRun,
};

export const EVENT_TYPE_TO_PLACEHOLDER_TOKEN: Record<EventType, string> = {
  [EventType.Account]: 'act_123',
  [EventType.Case]: 'case_123',
  [EventType.CaseMessage]: 'cmsg_123',
  [EventType.Document]: 'doc_123',
  [EventType.ExternalIntegrationLog]: 'eil_123',
  [EventType.GraphQuery]: 'grphq_123',
  [EventType.Inquiry]: 'inq_123',
  [EventType.InquiryTemplateVersion]: 'itmplv_123',
  [EventType.Report]: 'rep_123',
  [EventType.SAR]: 'sar_123',
  [EventType.Selfie]: 'self_123',
  [EventType.Session]: 'iqse_123',
  [EventType.Transaction]: 'txn_123',
  [EventType.Verification]: 'ver_123',
  [EventType.WorkflowRun]: 'wfr_123',
};
